import { SelectItem } from 'primeng/api';

export enum AdsCaseStatus {
  RequiresQuote = 'REQUIRES_QUOTE',
  QuotePendingApproval = 'QUOTE_PENDING_APPROVAL',
  QuotePendingApprovalInternal = 'QUOTE_PENDING_APPROVAL_INTERNAL',
  RequiresAdConfirmation = 'REQUIRES_AD_CONFIRMATIONS',
  SendAdSchedule = 'SEND_AD_SCHEDULE',
  InProgressAdStorage = 'IN_PROGRESS_AD_STORAGE',
  ETearReady = 'E_TEAR_READY',
  Completed = 'COMPLETED',
  OnHold = 'ON_HOLD',
  Canceled = 'CANCELED',
  Unassigned = 'UNASSIGNED',
  NeedsReview = 'NEEDS_REVIEW',
  Draft = 'DRAFT',
  InternalReview = 'INTERNAL_REVIEW',
}

export const ADS_CASE_STATUS: SelectItem[] = [
  { label: 'Requires Quote', value: AdsCaseStatus.RequiresQuote },
  { label: 'Quote Pending Approval', value: AdsCaseStatus.QuotePendingApproval },
  { label: 'Approved Quote', value: AdsCaseStatus.QuotePendingApprovalInternal },
  { label: 'Requires Ad Confirmations', value: AdsCaseStatus.RequiresAdConfirmation },
  { label: 'Send Ad Schedule', value: AdsCaseStatus.SendAdSchedule },
  { label: 'In Progress Ad Storage', value: AdsCaseStatus.InProgressAdStorage },
  { label: 'ETear Ready', value: AdsCaseStatus.ETearReady },
  { label: 'Completed', value: AdsCaseStatus.Completed},
  { label: 'On Hold', value: AdsCaseStatus.OnHold },
  { label: 'Canceled', value: AdsCaseStatus.Canceled },
  { label: 'Unassigned', value: AdsCaseStatus.Unassigned },
  { label: 'Needs Review', value: AdsCaseStatus.NeedsReview },
  { label: 'Internal Review', value: AdsCaseStatus.InternalReview },
];

// This is used to display all case status on the Customer/Company/Client Side.
// For dropdowns (e.g tables), you need special handling to query these using queryTransform
// If dropdowns not in tables or custom tables you'll need to flatten the array then do your manually query
export const ADS_CASE_STATUS_COMPANY: SelectItem[] = [
  { label: 'Quote In Progress', value: [
      AdsCaseStatus.RequiresQuote,
      AdsCaseStatus.Unassigned,
      AdsCaseStatus.NeedsReview,
      AdsCaseStatus.InternalReview,
  ]},
  { label: 'Quote Requires Approval', value: [AdsCaseStatus.QuotePendingApproval] },
  { label: 'Approved-Pending Schedule', value: [
      AdsCaseStatus.QuotePendingApprovalInternal,
      AdsCaseStatus.RequiresAdConfirmation,
      AdsCaseStatus.SendAdSchedule,
  ]},
  { label: 'Ad Schedule Available', value: [
      AdsCaseStatus.InProgressAdStorage,
      AdsCaseStatus.ETearReady,
    ] },
  { label: 'Completed', value: [AdsCaseStatus.Completed]},
  { label: 'On Hold', value: [AdsCaseStatus.OnHold] },
  { label: 'Canceled', value: [AdsCaseStatus.Canceled] },
  { label: 'Draft', value: [AdsCaseStatus.Draft] },
];
